import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import Image from '../../../components/AppImage';

const PersonnelAssignment = ({ assignedPersonnel, onAddPersonnel, onRemovePersonnel, availablePersonnel, errors }) => {
  const [selectedPerson, setSelectedPerson] = React.useState('');

  const handleAddPerson = () => {
    if (selectedPerson && !assignedPersonnel?.find(p => p?.id === selectedPerson)) {
      const person = availablePersonnel?.find(p => p?.value === selectedPerson);
      if (person) {
        onAddPersonnel({
          id: person?.value,
          name: person?.label,
          role: person?.role,
          avatar: person?.avatar,
          avatarAlt: person?.avatarAlt
        });
        setSelectedPerson('');
      }
    }
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name="Users" size={20} color="var(--color-primary)" />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-foreground">Personnel Assignment</h2>
          <p className="text-sm text-muted-foreground">Assign workers and supervisors to this permit</p>
        </div>
      </div>
      <div className="space-y-4">
        <div className="flex gap-3">
          <div className="flex-1">
            <Select
              options={availablePersonnel}
              value={selectedPerson}
              onChange={setSelectedPerson}
              placeholder="Search and select personnel..."
              searchable
            />
          </div>
          <Button
            variant="default"
            iconName="Plus"
            onClick={handleAddPerson}
            disabled={!selectedPerson}
          >
            Add
          </Button>
        </div>

        {errors?.personnel && (
          <p className="text-sm text-error">{errors?.personnel}</p>
        )}

        {assignedPersonnel?.length > 0 ? (
          <div className="space-y-3">
            <div className="flex items-center justify-between pb-2 border-b border-border">
              <span className="text-sm font-medium text-foreground">
                Assigned Personnel ({assignedPersonnel?.length})
              </span>
            </div>
            <div className="space-y-2">
              {assignedPersonnel?.map((person) => (
                <div
                  key={person?.id}
                  className="flex items-center gap-3 p-3 rounded-lg border border-border bg-background hover:bg-muted/50 transition-colors"
                >
                  <div className="w-10 h-10 rounded-full overflow-hidden bg-muted flex-shrink-0">
                    <Image
                      src={person?.avatar}
                      alt={person?.avatarAlt}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="font-medium text-foreground">{person?.name}</p>
                    <p className="text-sm text-muted-foreground">{person?.role}</p>
                  </div>
                  <Button
                    variant="ghost"
                    size="icon"
                    iconName="X"
                    onClick={() => onRemovePersonnel(person?.id)}
                  />
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="text-center py-8 border-2 border-dashed border-border rounded-lg">
            <Icon name="UserPlus" size={32} color="var(--color-muted-foreground)" className="mx-auto mb-3" />
            <p className="text-sm text-muted-foreground">No personnel assigned yet</p>
            <p className="text-xs text-muted-foreground mt-1">Add workers and supervisors from the dropdown above</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PersonnelAssignment;